import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getListAudioAnnouncementFiles } from '../../services/AudioAnnouncementService';
import type { AudioAnnouncementFile } from '../../types/AudioAnnouncement';

function useGetAudioAnnouncementFiles(
  fleetId: string,
): UseQueryResult<AudioAnnouncementFile[]> {
  return useQuery(
    ['audio-announcement', fleetId],
    (): Promise<AudioAnnouncementFile[]> => getListAudioAnnouncementFiles(fleetId),
    {
      retry: 1,
      enabled: Boolean(fleetId),
      refetchOnWindowFocus: false,
    },
  );
}

export default useGetAudioAnnouncementFiles;
